/// <amd-module name="Environments/EnvironmentTraceabilityChanges/Stores/CommitsStore" />
import { ActionsHubManager } from "Environments/Flux/ActionsHubManager";
import { CommitsActions } from "Environments/EnvironmentTraceabilityChanges/Actions/CommitsActions";
import { StoreBase } from "Environments/Flux/Store";
import { EnvironmentCommitsRecord, EnvironmentPipelineRepositoryData } from "Environments/RemoteClients/Contracts/Traceability";
import { ICommitsResult } from "Environments/Client/EnvironmentContracts";

export class CommitsStore extends StoreBase {

    public static getKey(): string {
        return "commits-store";
    }
    
    public initialize(instanceId: string): void {
        super.initialize(instanceId);
        this._state = {
            commits: []
        }

        this._actionsHub = ActionsHubManager.GetActionsHub<CommitsActions>(CommitsActions, instanceId);
        this._actionsHub.setCommits.addListener(this._handleSetCommits);
    }

    public getState(): ICommitsResult {
        return this._state;
    }

    public getCommits(): EnvironmentCommitsRecord[] {
        return this._state.commits ? this._state.commits : [];
    }

    public getRepoInfo(): EnvironmentPipelineRepositoryData | undefined{
        return this._state.repo;
    }
    
    protected disposeInternal(): void {
        this._actionsHub.setCommits.removeListener(this._handleSetCommits);
    }

    private _handleSetCommits = (commitsData: ICommitsResult) => {
        if (commitsData) {
            this._state = {
                commits: commitsData.commits || [],
                repo: commitsData.repo
            } as ICommitsResult;
            
            this.emitChanged();
        }
    }

    private _actionsHub: CommitsActions;
    private _state: ICommitsResult;
}
